export default __webpack_public_path__ + "static/media/next.bfb23e82.svg";